import React from 'react';
import PropTypes from 'prop-types';

const PageTitle = ({ title, className, actions }) => {
  return (
    <div className={`page-title-box d-flex flex-wrap align-items-center justify-content-between gap-3 ${className || ''}`}>
      <h2 className="page-title">{title}</h2>
      {actions ? <div className="page-title-actions">{actions}</div> : null}
    </div>
  );
};

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  actions: PropTypes.node,
};

export default PageTitle;
